/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";

export const Screen = styled.div`
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    gap: 24px;
`;

export const Headline = styled.h1`
    margin: 0;
    padding: 0;

    font-family: "Custora";
    font-weight: 400;
    font-size: 36px;
    line-height: 130%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #e9ecf5;
`;

export const Subhead = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 400;
    font-size: 18px;
    line-height: 140%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #b7bdcb;
`;

export const SectionLabel = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #e9ecf5;
`;

export const FullWidth = styled.div`
    width: 100%;
`;

export const GoogleButton = styled.button`
    width: 100%;
    height: 48px;

    background: #ffffff;
    border: 1px solid #8097ea;
    border-radius: 10px;

    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 44.61px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #23252a;

    cursor: pointer;

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

export const GoogleIcon = styled.img`
    position: absolute;
    left: 38px;
    width: 18px;
    height: 18px;
    display: block;
`;

export const DividerWrap = styled.div`
    width: 100%;
    display: grid;
    place-items: center;
`;

export const Divider = styled.div`
    width: 100%;
    position: relative;
    display: grid;
    place-items: center;

    &:before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 1px;
        background: #2b2d33;
    }
`;

export const DividerText = styled.span`
    position: relative;
    z-index: 1;

    padding: 0 14px;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 44.61px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #b7bdcb;

    background: #1A1A1C;
`;

export const ContinueButton = styled.button`
    width: 100%;
    height: 48px;

    background: #5e84ed;
    border: none;
    border-radius: 10px;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 44.61px;
    letter-spacing: 0px;
    text-align: center;

    color: #ffffff;

    cursor: pointer;

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

export const ErrorText = styled.p`
    margin: 0;
    padding: 0;

    font-family:
        Inter,
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 140%;
    text-align: center;

    color: #ff8a8a;
`;

export const SpinnerWrap = styled.div`
    margin-top: 12px;
    display: grid;
    place-items: center;
`;

export const LinkText = styled.span`
  cursor: pointer;
  color: #5E84ED;
  font-size: 15px;
  font-family: Inter, sans-serif;
  font-weight: 500;
  word-wrap: break-word;
`;

export const NewToMailanderWrapper = styled.div`
  justify-content: center;
  align-items: center;
  gap: 10px;
  display: flex;
  color: #6B6F78;
  font-size: 14px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  word-wrap: break-word;
  width: 100%;
`;

export const Line = styled.div`
    display: flex;
    flex: 1;
  height: 0px;
  outline: 1px #2B2D33 solid;
  outline-offset: -0.50px;
`;